import React from 'react';
import properties from '../../constants/Properties';
import appParameters from '../utils/AppParameters';
import locales from '../../locales/LocalesManager';
import mouseUtils from '../../components/utils/MouseUtils';
import helpUtils from '../utils/HelpUtils';
import saveManager from '../utils/SaveManager';
import configuration from '../../constants/Configuration';
import platformDetection from '../utils/PlatformDetection';
import apiServiceUtils from '../utils/ApiServiceUtils';

const Button = React.createClass({
    getInitialState() {
        helpUtils.closeTitleAlert = this.closeTitleAlert;

        return ({
            isOver: false
        });
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onButtonClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.closeTitleAlert();
    },
    closeTitleAlert() {
        var titleInput = document.getElementById('productionInitialTitle');

        if (titleInput && titleInput.value.length > 0)
            appParameters.title = titleInput.value;

        helpUtils.initialTitleChecked = true;
        helpUtils.titleAlertVisible = false;

        if (this.props.refreshContent)
            this.props.refreshContent();
    },
    render() {
        var textColor;
        var fillColor;

        if (this.state.isOver == true) {
            fillColor = properties.SLIDE_VIEWER_BACKGROUND;
            textColor = 'black';
        } else {
            textColor = 'black';
            fillColor = '#f2f2f2';
        }

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: fillColor,
            width: properties.DELETE_ALERT_BUTTON_WIDTH,
            height: properties.DELETE_ALERT_BUTTON_HEIGHT,
            top: this.props.topPosition,
            left: this.props.leftPosition,
            borderRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#333333'
        };

        const spanStyle = {
            position: 'absolute',
            top: 6,
            fontSize: 16,
            width: properties.DELETE_ALERT_BUTTON_WIDTH - 6,
            whiteSpace: 'nowrap',
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center',
            textAlign: 'center',
            cursor: 'default',
            color: textColor
        };

        return (
            <button aria-label={this.props.text} data-dismiss="modal" id="productionInitialTitleButton" style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onButtonClick} onClick={this.onButtonClick}>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

export const ProductTitleAlert = React.createClass({
    getInitialState () {
        this.changeSelection();

        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onInputClick() {
        this.changeFocus();
    },
    changeFocus() {
        var view = this.refs.productionTitle;

        if (view)
            view.focus();
    },
    refresh() {
        this.forceUpdate();
    },
    getDefaultTitle() {
        if (appParameters.title == appParameters.defaultTitle) {
            var date = new Date();
            var title = '';

            if (appParameters.title == 'Cartoonist')
                title = title + 'Cartoonist (';
            else
                title = title + 'AudioEditor (';

            title = title + date.getFullYear() + '.';

            if ((date.getMonth() + 1) > 9)
                title = title + (date.getMonth() + 1) + '.';
            else
                title = title + '0' + (date.getMonth() + 1) + '.';

            if (date.getDate() > 9)
                title = title + date.getDate() + ')';
            else
                title = title + '0' + date.getDate() + ')';

            return title;
        } else
            return appParameters.title;
    },
    changeSelection() {
        if (platformDetection.isIOSApp())
            return;

        setTimeout(function() {
            if (this.refs.productionTitle) {
                this.refs.productionTitle.focus();
                this.refs.productionTitle.setSelectionRange(0, 100);
            }
        }.bind(this), 100);
    },
    render() {
        var visible = 'none';

        if (!helpUtils.initialTitleChecked && appParameters.isMaster && !configuration.LOAD_LOCAL)
            visible = 'block';
        else
            return (<div/>);

        helpUtils.titleAlertVisible = true;

        const menuStyle = {
            position: 'absolute',
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            left: 0,
            display: visible,
            zIndex: 20000
        };

        const backgroundStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: 0,
            left: 0,
            opacity: properties.DELETE_ALERT_BACKGROUND_OPACITY
        };

        const bottomBarHeight = 120;
        const alertHolderStyle = {
            position: 'absolute',
            top: 200,
            left: this.props.windowWidth / 2 - properties.DELETE_ALERT_WIDTH / 2
        };

        const topBarStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: properties.DELETE_ALERT_WIDTH,
            height: properties.DELETE_ALERT_TOP_BAR_HEIGHT,
            top: 0,
            left: 0,
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: properties.DELETE_ALERT_BACKGROUND
        };

        const bottomBarStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: properties.DELETE_ALERT_WIDTH,
            height: bottomBarHeight,
            top: properties.DELETE_ALERT_TOP_BAR_HEIGHT,
            left: 0,
            borderBottomLeftRadius: 3,
            borderBottomRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: 'white'
        };

        var paddingLeft = 15;
        const titleStyle = {
            position: 'absolute',
            left: paddingLeft,
            top: 7,
            fontSize: 20,
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            color: 'white'
        };

        var borderColor;
        var textColor;

        if (this.state.isOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            textColor = borderColor;
        } else {
            borderColor = 'black';
            textColor = 'black';
        }

        const inputHolderStyle = {
            width: topBarStyle.width - 2 * paddingLeft,
            height: 30,
            background: 'white',
            position: 'absolute',
            left: paddingLeft,
            top: paddingLeft,
            borderColor: borderColor,
            borderWidth: 2,
            borderStyle: 'solid',
            alignItems: 'center',
            border: 'none'
        };

        var inputStyle = {
            position: 'absolute',
            color: textColor,
            top: 5,
            paddingLeft: 10,
            fontSize: 17,
            width: inputHolderStyle.width - 2 * 10,
            resize: 'none',
            overflow: 'hidden',
            background: 'transparent',
            borderColor: borderColor,
            borderRadius: 5
        };

        if (platformDetection.isIOS())
            inputStyle.top = -3;

        return (
            <div style={menuStyle} role="dialog" id="productionInitialTitleAlert">
                <div style={backgroundStyle}/>
                <div style={alertHolderStyle}>
                    <div style={topBarStyle}>
                        <label htmlFor='productionInitialTitle' style={titleStyle}>{locales.getCaption('ProductionNameAlertTitle', 'other')}</label>
                    </div>
                    <div style={bottomBarStyle}>
                        <div style={inputHolderStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onInputClick}>
                            <input type='text' ref='productionTitle' id='productionInitialTitle' className='titleInput' style={inputStyle} defaultValue={this.getDefaultTitle()} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off'/>
                        </div>
                        <Button  dispatch={this.props.dispatch} topPosition={bottomBarHeight - paddingLeft - properties.DELETE_ALERT_BUTTON_HEIGHT} leftPosition={bottomBarStyle.width - properties.DELETE_ALERT_BUTTON_WIDTH - paddingLeft} refreshContent={this.refresh} text={'OK'}/>
                    </div>
                </div>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/ProductTitleAlert.js
 **/